export const groupRoleMapping = (allGroups) => {
    const transformed = {};
    allGroups.groups.forEach((item) => {
       if (item.includes(' - ')) {
           const [key, value] = item.split(' - ').map((str) => str.trim());
           if (!transformed[key]) {
           transformed[key] = [];
           }
          transformed[key].push(value);
        } else {
           if (!transformed.Other) {
           transformed.Other = [];
           }
           transformed.Other.push(item);
         }
       });
     return transformed;
 }
